module.exports = __webpack_public_path__ + "img/card_title01.acbf93ea.png";